<template>
  <div class="pc_detail">
      <PcHome></PcHome>
      <div class="pictrue">
          <div class="left">
              <div class="picbox">
                  <span ><img style="width:100%" :src="imgUrl" /></span>
              </div>
              <div >
                  <span :class="{'minPic':true,'active':imgUrl == img}" @mouseenter="inginfk(img)" v-for="(img,index) in mainImgs " :key="index" ><img style="width:100%" :src="img" /></span>
              </div>
          </div>
          <div class="rigth">
              <div class="titleEds">{{productData.name}}</div>
              <div class="inlg" style="color:red">{{$t('other.a1713')}}：￥
                  <span v-if="storeItem.price.length > 1">{{storeItem.price[0]}}~{{storeItem.price[1]}}</span>
                  <span v-else>{{storeItem.price[0]}}</span>
              </div>
              <div style="margin-bottom:10px">{{$t('other.a1714')}}：{{storeItem.amount}}</div>
              <div class="okukjg">
                  <el-button style="width:150px" type="warning" @click="distribute()">{{$t('other.a1715')}}</el-button>
              </div>
              <div>
                  <div style="margin-bottom:20px">{{$t('other.a335')}}({{storeItem.storeItems.length}})：</div>
                  <div class="sku" v-for="(skuItem,index) in storeItem.storeItemsCopy" :key="index">
                      <span class="skuItem">sku:{{skuItem.skuName}}</span>
                      <span class="skuItem">{{$t('other.a1713')}}:￥{{skuItem.price}}</span>
                      <span class="skuItem">{{$t('other.a1716')}}:{{skuItem.stock}}</span>
                  </div>
              </div>
              <!-- <div class="ttp">展开剩余sku</div> -->
             
          </div>

      </div>
      <div>
          <div class="pppmiuj">{{$t('other.a318')}}</div>
          <div>
              <el-input
                type="textarea"
                autosize
                :placeholder="$t('other.a319')"
                v-model="productData.description">
                </el-input>
          </div>

      </div>

      <div class="jgknv">
           <div class="pppmiuj">{{$t('other.a1717')}}</div>
           <div v-for="(item, index) in mainImgs" :key="index">
               <img style="width:100%" :src="item" />
           </div>
           
       </div>
      
  </div>
</template>

<script>
import api from '../../../api/api'
import newOrdersApi from '../../../api/moudles/newOrders'
import userStoreItems from "../../../api/moudles/userStoreItems";
import utils from '../../../utils/utils'
import PcHome from './PC_home'
export default {
data(){
return{
    storeItem:null,
    productData:null,
    mainImgs:[],
    imgUrl:null,
}
},
components:{
    PcHome
},
created(){
    this.getData()
},
methods:{

    distribute(){
        let userInfo=JSON.parse(localStorage.getItem('userInfo'))
        if(!userInfo){
            this.$confirm(this.$t("other.a1718"), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a955'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {

                this.$router.push({
                path:'/loginPage',
                query:{
                  Distribution:0
                }
              })

            })
            
            return
        }

        this.storeItem.userId=userInfo.userId
        this.$confirm(this.$t("other.a1719"),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a235'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(res => {
            api
            .copyStoreItem(this.storeItem)
            .then(res => {
            if(res.code === 200) {
                this.$confirm(this.$t("other.a1720"), this.$t("other.a142"), {
                confirmButtonText: this.$t("other.a1721"),
                cancelButtonText: this.$t("other.a1722"),
                type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/distributeProduct/hasAgent',
                      
                    })
                })
                if(res.data.storeItems){
                  res.data.storeItems.forEach(p => {
                    p.synchrony=true
                    this.updataSync(p)
                  })
                }
            }else{
                this.$message.warning(res.msg)
            }
            })

        })
        
        
    },

    updataSync(ttp){
      userStoreItems
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },
    inginfk(item){
        console.log(item)
        this.imgUrl=item
    },

    getData(){
        let id=this.$route.query.groupId
        let productId=this.$route.query.productId

        
        if(id){
            api
            .getStoreItemByGroupId({groupId:id})
            .then(res => {
            if(res.code === 200 ){
            this.storeItem=res.data
            this.storeItem.amount=0
            this.storeItem.price=[]
            
            this.storeItem.storeItems.forEach(i => {
                this.storeItem.amount+=i.stock
                i.price = i.price.toFixed(2)
                this.storeItem.price.push(i.price)
            })
            console.log('id',this.storeItem)
            this.storeItem.price=[...new Set(this.storeItem.price)]
            if(this.storeItem.price.length> 1){
                this.storeItem.price.sort((a,b) => {return a-b})
            }

            this.storeItem.storeItemsCopy=this.storeItem.storeItems.slice(0,4)

            }else{
            this.$message.warning(res.msg)
            }
            })
        }


        if(productId){
            api
            .getProductByproductId({productId:productId})
            .then(res => {
            if(res.code === 200 ){
            console.log('productId',res.data)
            this.productData=res.data
            this.mainImgs=this.productData.images.map(p => {
                return p.image
            })
            this.imgUrl=this.mainImgs[0]
            console.log(this.mainImgs)
            }else{
            this.$message.warning(res.msg)
            }
            })

        }
    }

}
}

</script>
<style lang='scss' scoped>
.pc_detail{
    width: 1200px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: #fff;

    .pppmiuj{
        font-size: 25px;
        font-weight: bold;
        margin:10px 0 ;
        border-bottom: 1px solid #eee;
    }

    .pictrue{
        display: flex;
        border-bottom: 1px solid #eee;

        .left{
            width: 450px;
            overflow: hidden;
        }

        .rigth{
            flex: 1;

            .titleEds{
                font-size: 20px;
                font-weight: bold;
            }

            .inlg{
                margin: 10px 0;
                font-size: 25px;
            }

            .ttp{
                text-align: center;
                color: red;
                cursor: pointer;
                border-bottom: 1px solid #eee;
            }


            .okukjg{
                margin: 20px 0;
            }

            
            
        }


        .picbox{
            width: 419px;
            height: 419px;
            overflow: hidden;
        }

        .minPic{
            display: inline-block;
            margin: 3px ;
            width: 60px;
            height: 60px;
            overflow: hidden;
            cursor: pointer;
        }

        .active{
            border: 1px solid red;
        }
    }

    .sku{

        border-bottom: 1px solid #eee;
        padding: 3px 0;

        .skuItem{
            display: inline-block;
            width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            
        }
    }
}
</style>